import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { List, Spin } from 'antd'
import { LoadingOutlined, GlobalOutlined } from '@ant-design/icons'

import { setCountrySelected } from 'store/global/countrySelected'
import { setViewStateStore } from 'store/global/map/viewState'
import { setLayersInfo } from 'store/global/map/layersInfo'
import { cleanSideBarInfo } from 'store/global/map/sideBarInfo'

import RpcApiClient from 'datasources/RpcApiClient'

function Countries(props) {
  const dispatch = useDispatch()
  const history = useHistory()
  const authData = useSelector((state) => state.auth.authData)

  const [loadingMaps, setLoadingMaps] = useState(false)
  const [maps, setMaps] = useState([])

  const sortMaps = (maps) => {
    maps.sort((a, b) => {
      const countryA = a.country.toUpperCase()
      const countryB = b.country.toUpperCase()
      if (countryA < countryB) {
        return -1
      }
      if (countryA > countryB) {
        return 1
      }

      // names must be equal
      return 0
    })
  }

  const getMaps = () => {
    setLoadingMaps(false)
    RpcApiClient.getUserMaps(authData.jwtToken).then((data) => {
      sortMaps(data.data.data)
      setMaps(data.data.data)
      setLoadingMaps(true)
    })
  }

  useEffect(() => {
    getMaps()
  }, [])

  if (!loadingMaps)
    return (
      <div style={{ height: '100px', width: '100%' }}>
        <Spin style={{ marginTop: '10%' }} tip="Loading..." size="large" indicator={<LoadingOutlined />}>
          <div style={{ height: '100%', width: '100%' }}></div>
        </Spin>
      </div>
    )
  return (
    <List
      itemLayout="horizontal"
      dataSource={maps}
      loading={!loadingMaps}
      renderItem={(map) => (
        <List.Item
          actions={[
            <a
              style={{ color: '#cc7252' }}
              onClick={() => {
                props.onSelect()
                dispatch(setCountrySelected(map))
                history.push('/map')
                dispatch(setLayersInfo([]))
                dispatch(
                  setViewStateStore({
                    bearing: parseFloat(map.map_location.bearing),
                    latitude: parseFloat(map.map_location.latitude),
                    longitude: parseFloat(map.map_location.longitude),
                    pitch: parseFloat(map.map_location.pitch),
                    zoom: parseFloat(map.map_location.zoom),
                    country: parseFloat(map.map_location.country),
                  }),
                )
                dispatch(cleanSideBarInfo([]))
                dispatch(setLayersInfo([]))
              }}
            >
              Select
            </a>,
          ]}
        >
          <List.Item.Meta title={map.country} avatar={<GlobalOutlined />} />
        </List.Item>
      )}
    />
  )
}

export default Countries
